import { render, staticRenderFns } from "./Rika.vue?vue&type=template&id=7de87fa8&scoped=true&"
import script from "./Rika.vue?vue&type=script&lang=js&"
export * from "./Rika.vue?vue&type=script&lang=js&"
import style0 from "./Rika.vue?vue&type=style&index=0&id=7de87fa8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de87fa8",
  null
  
)

export default component.exports